import React from 'react';
import { Artifact } from '../../../types/artifact';
import { useTheme } from '../../../contexts/ThemeContext';

interface DiagramArtifactViewerProps {
  artifact: Artifact;
  mode?: 'default' | 'interactive' | 'static';
}

export const DiagramArtifactViewer: React.FC<DiagramArtifactViewerProps> = ({ 
  artifact, 
  mode = 'default' 
}) => {
  const { darkMode } = useTheme();

  const getDiagramContent = () => {
    if (typeof artifact.content === 'string') {
      if (artifact.content.startsWith('http')) return { url: artifact.content };
      if (artifact.content.startsWith('data:')) return { image: artifact.content };
      return { text: artifact.content };
    }
    return artifact.content;
  };

  const diagram = getDiagramContent();

  const renderStatic = () => {
    if (diagram.image || diagram.url) {
      return (
        <div className="flex justify-center">
          <img
            src={diagram.image || diagram.url}
            alt={artifact.name}
            className="max-w-full max-h-[600px] object-contain"
          />
        </div>
      );
    }
    if (diagram.svg) {
      return (
        <div className="flex justify-center" dangerouslySetInnerHTML={{ __html: diagram.svg }} />
      );
    }
    return (
      <div className={`text-center py-8 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        No diagram image available
      </div>
    );
  };

  const renderInteractive = () => (
    <div className="text-center py-8">
      <p className={`mb-4 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        Interactive diagram viewer not implemented
      </p>
      {renderStatic()}
    </div>
  );

  switch (mode) {
    case 'interactive': return renderInteractive();
    case 'static': return renderStatic();
    default: return renderStatic();
  }
};
